import { render, staticRenderFns } from "./ratioPopup.vue?vue&type=template&id=4019a5ec&"
import script from "./ratioPopup.ts?vue&type=script&lang=js&"
export * from "./ratioPopup.ts?vue&type=script&lang=js&"
import style0 from "./ratioPopup.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports